var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCargo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "62 16.73 659 462.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M268 22h1c19 3 13 14 11 35l-17 11c-2 21 18 33-2 31v-1c-20-3-34-22-32-43s19-36 39-33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 48v3l-2 4-1 4c-1 6 0 10 1 12 1 3 3 3 3 5s-3 3-6 4c0 0-2 5-1 6 0 2-3 2-3 1-1 1 2 2 1 3l-3 3s-4 10-8 10l-14-4s-30-8-18-48c0 0 12-36 36-26 0 0 13-2 15 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 35c2 1 2 4 3 6 2 5 4 11 3 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 35c2 1 3 5 4 8 2 4 5 8 4 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 31c5 2 7 7 9 11l5 6c1 2 3 6 1 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 46c-2-7-8-13-14-16l-6-2m-1 1s3-4-10-9c-13-4-23 0-34 40-12 39-20 41-24 47 0 0 9-3 18-17 0 0-13 19-19 24 0 0 14-5 21-17l-9 17s41-51 53-79m-41 2-4 10-4 9-6 11-6 9-5 6c-2 3-4 6-7 7l-3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223 60-4 7c-4 7-15 23-21 29m56-35v-1l-3 7-4 11-4 11c-3 6-13 24-19 27m-4-66s-19 0-34 37c0 0-12 14-23 16-5 2 18 0 29-16 0 0 10-21 25-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 80c0 2 4 0 0 17s0 8-2 11c0 0 17 17 24 16 0 0-2-15 3-26l-25-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237 79-2 1-1 5m3-4-1 1-1 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 80c-1-2-4 2-4 4m6-1c-1-1-1 1-1 1l-1 5m-13-30-4 10-7 18c-3 7-8 13-12 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 67-1 2v1l-3 11-2 9-9 18m48-40s0-1 0 0l-2 6-1 2-3 9-3 9m-26-11v-1l-3 11-8 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 81c-3 9-8 17-12 26m-4-5 4-6 6-10 2-5 3-6 3-8 3-5m-26 26c0-2 2-4 4-5l7-10 3-5 2-5 4-7m-7 55 4-8 4-5 3-5 5-8 6-15 4-8m32-45c14 2 25 16 23 30l-1 5c-3 11-14 19-27 17-14-2-25-15-23-30 1-14 14-24 28-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 56s0 3 3 4h3l-5 2m-41-34s-23 12-24 28l-13 48-5 7 17-16s9-10 12-19l8-20 5-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 57s-15 39-20 41c0 0 9-8 21-28m-1-11 1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 60-3 3-4 5-8 5-11 6-5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 84c3 0 6-4 9-6l10-6 5-3 1-2 4-4v-2l1-6 2-4m-37 150s3-1 10-23c8-26 5-29 13-48 7-19 9-16 28-36l21 25s5 8 3 14c-3 13-16 34-19 52-3 12 1 9-1 19-5 25-19 26-19 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 121s30 40 4 46-5-47-4-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 175s45 11 70 22c4 2 4 14 0 13l-2 2h-3c-2 3-5 1-6 1-2 2-4 0-4-2 0 0 1-6-2-7 0 0-53-6-63-10 0 0-8 4-12-17l-9-37s-4-12 2-17c6-4 12-6 18 7l11 45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 156s34 17 51 29c5 4 11 5 6 12-6 8-11 3-11 0 0 0-1-5-4-7 0 0-43-9-51-14 0 0-6 4-8-18l-6-39s-2-13 3-17c5-5 10-6 13 7l6 38 1 9Zm-23 49s-49 13-33 39c0 0 65 30 91 38l-19 26-35 56s-14 31 10 36c0 0 8 14 16 10 8-3 16-8-4-28v-22s27-27 47-54l13-17s17-20 3-32l-89-52Zm-37-19c-1 2-6 3-4 6 0 0-4 3-3 5h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 211s2-2 1 0l-1 3m34-175s5-7-13-16-32 0-48 73c-17 74-28 77-33 87 0 0 11-5 24-31 0 0-18 36-27 44 0 0 21-8 30-31 0 0 5-7-12 31 0 0 58-94 74-146m-58 4c-3 5-4 11-6 17l-5 18-8 21-9 16-7 12c-3 5-6 10-10 13l-4 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199 96-5 14c-6 12-22 43-30 54m92-146s-37-9-59 61c0 0-17 25-31 30-7 2 25-1 40-30 0 0 21-35 43-45m-32 99c-1-4-6 5-6 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199 94-6 19-9 33-17 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 109-2 3v4l-4 20c-1 6-1 11-3 16-3 12-8 23-12 34m18-47 1-2-6 21-11 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 136c-4 17-11 31-16 47m-6-8 6-12c3-6 6-11 8-18l3-10 4-10 4-15 4-10m-36 49c1-5 3-8 5-11l11-18 4-9 3-9 5-13m-10 101 7-14 5-9 4-10 7-15c4-8 6-18 9-28l5-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 33s-32 24-34 54c0 0-10 61-18 88l-7 13 23-30s13-17 18-34l11-37 8-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 91s-20 72-28 77c0 0 12-16 29-53m-1-20 1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 96c-2 1-3 4-5 7l-5 8c-3 4-8 7-12 10l-15 11-7 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 140c4 1 9-6 13-9l15-12 6-6 1-4 5-7 1-4 2-11 2-8m-7 114-4 4c-8 11-24 36-5 50 0 0 88 53 115 51 0 0-5 9-16 48l-14 64s-2 34 22 31c0 0 12 10 19 4 6-6 11-14-14-25l-7-21s16-36 26-68c3-7 8-22 9-29 0 0 5-16-12-21l-119-88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 237 34 69s0 5 6 1l3 7s15-1 26-8l15-10m-52-88s4 1 1 3m72-20-24 3s-4 3-1 7l24-2 6 1 3 1s1-10-2-13l-3 1-3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 188s19 1 24 7c0 0 13 9 2 32 0 0-6 17-3 24 0 0-2 3-8 1 0 0-1-12 4-22 0 0 6-18 3-26 0 0-7-8-21-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 192s-2-5 2-6c0 0 12-2 15 7 0 0-2 4-7 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 188s0-4-4-3c0 0-3 2-2 4 0 0 2-3 6 0m10 9 11 3c-1 1-1 2-9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 201h9l4 2c0 4-9 12-11 14-2 1-10 13-13 19-3 4-2 7-3 9l1 6h-2l-1-1s-1-9 5-17c0 0 10-16 14-19l9-9c0-1-2-5-12-3-11 2-13-3-13-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 204s12 3 10 4h-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 207h8c2 1 5 1 5 3-1 4-9 12-12 13l-8 13c-3 4-3 10-3 12v3h-2v-5l3-9s7-14 12-16c0 0 8-8 8-10 1-1-1-5-12-3-11 3-12-3-12-3m-24-6-23 5s-3 4 0 8l24-5 6 1h2s0-10-3-13l-2 1-3 3m22-1s-3-5 1-7c0 0 11-2 15 6 0 0 0 4-6 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 193s-1-3-4-2c0 0-3 2-2 4 0 0 2-3 6 0m-13 13 14-1-3-10h-14m5 58s7-8 16-4l13 37-17 7-12-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342 295 34 118 7 10 185 1s48-77 68-92l2-2 7 2s6-3 3-9c0 0-111-33-173-37-65-4-120 0-120 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 309-1-1s12-8 17-5l21 37s7 15 25 19l56-1h23l5 17h-53s-36 4-50-5c0 0-10-4-20-21-11-17-23-40-23-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194 260 30 47 6-3-29-46-7 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 299s-6 0-4 4c0 0 1 2 5-1l9-6s3-3-1-2c-4 0-4 2-4 2m-29-35-6-1 1-7 10-2 3 1-2 6-6 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202 254 6-7-2-1-5 6m21 57s-39 18-54 32c0 0-13 7-10 23 3 12 11 20 12 20 0 0 9-3 10-7 1-3-26-15 2-34l43-28-3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 374h119s5-2 12 7l10 12s4 5 4 11c0 10-16 25-16 25l-6-4s14-16 13-20c-1-9-14-21-16-22l-8-1H174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 382 26 34s6 8 14 9l77 12s12 2 21-10l-4-3s-10 6-20 5l-23-4s-21-2-34-5c-14-3-16-1-21-6-9-9-24-29-24-29l-1-4c0-2-11 1-11 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 376s-16 0-16 18c0 19 17 17 17 17s17 0 17-18c0-17-18-17-18-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170 404-1 6 105 7s12 0 13-10c2-13-10-15-15-15l-98-8 2 6 48 4 49 4s9 1 7 9c0 0 0 6-14 4l-93-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 380s-21 3-22 23c-2 19 7 23 9 24l31 4s19-12 21-24c1-11-15-24-18-26-3-3-21-1-21-1Zm28 48h78l1 11 16-4v-13l-17-2h-64s-5-1-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 436-4 1s0 3 2 3-3 1-1 2l2 1v2h3v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385 440 9-1v4h-10m10-5v5l191-6 1-5-192 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554 424-6 10 1 1 7-11h-2Zm4 0-7 10h2l6-10h-1Zm-11 9-1-2m0 3v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 433v-2h-2v3l2 4v1h4v-2m-31-13 1 16h7v-16h-8Zm-120-1s18 21 71 1l-3-2s-45 18-66 0c-22-17-2 1-2 1Zm-49-83 23 75-8 6-7-5-7-1-13-51s-3-9 4-19c7-9 8-5 8-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373 417 2 3h1l-3-4v1Zm-3-16h5l2 10-2 4-2-3 3-3-2-5h-3m214 28 9-1s8 0 11-6l9-20 9-20 10-18 2 5-19 41-7 14s-3 8-12 9l-12 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619 347 30 63s3 5 5 4c0 0 1-2-1-6l-27-69-7 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 405c5 0 10 4 10 9s-5 9-10 9-9-4-9-9 4-9 9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 346c-37 0-67 29-67 63v7c0 35 30 63 67 63s67-28 67-63v-7c0-34-30-63-67-63Zm-1 21c27 0 48 20 48 45v5c0 24-21 44-48 44-26 0-48-20-48-44v-5c0-25 22-45 48-45Zm-487-58c-48 0-86 35-86 79v9c0 44 38 79 86 79 47 0 86-35 86-79v-9c0-44-39-79-86-79Zm-1 26c34 0 61 25 61 56v6c0 31-27 57-61 57s-61-26-61-57v-6c0-31 27-56 61-56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 372v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 371s-18 11-25 11c0 0 16-13 22-24 6-10 16-32 46-42a95 95 0 0 1 86 10l10 11-15 5s-24-20-51-18c-59 4-71 42-73 47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86 345 3-1-2 5 2 1-6 11-4-2 7-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 421v40m0-41v42h1v-42h-1Zm10 0-1 41h1l1-41m-7 31v11h2v-11m-8-35-6 45h1l5-44 1-2s0-4-1-2v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630 458 27-40v2l-26 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624 452 33-34v1l-33 34m-6-5 30-38v2l-30 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m612 441 37-31-1 2-35 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607 433 47-12-1 1-45 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606 423 49-2h-2l-47 3m55-5 41-3m-41 3 41-2 1-1v-1l-42 3h-1l1 1Zm-1-10 42-1v-1l-42 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m656 421 46 4 1-1-46-3-2-1s-4 0-1 1h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700 434-42-24h2l40 24m-5 7-38-31 2 1 36 29m-5 7-40-27h2l39 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684 453-34-35 2 1 32 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676 458-15-45 1 1 15 44m-11 2-6-48 1 2 6 46m-9-54 1-40m-1 41 1-41v-1h-1v41l-1 1h1Zm-10 0 2-41h-1l-1 41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660 411 7-45h-1l-6 44-1 2s0 5 1 2v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677 369-28 40 1-2 26-38m7 6-34 34 1-1 32-33m7 5-31 37 1-2 29-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m694 386-37 31 1-2 36-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699 395-47 11 1-1 46-11m1 10-49 3 2-1 47-3m-54 5-41 3m41-3-41 3h-1v1l42-3h1l-1-1Zm1 10-42 1s0 2 1 1l42-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651 406-46-3h-1l46 3h3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607 393 42 24h-2l-40-24m5-7 38 31-2-1-36-29m5-7 40 27h-2l-39-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623 374 34 35-2-1-33-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631 369 15 45-1-1-15-44m11-2 6 48-1-2-6-46m-475 15c7 0 12 5 12 12s-5 12-12 12-13-5-13-12 6-12 13-12Zm-8 22v54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 403v57h2l-1-56 1-2-2 1Zm14 0-2 56s3 0 1-1l2-55m-10 42v15h3v-15m-11-47-8 60h1l8-60 1-2s0-6-1-2l-1 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133 454 37-53-1 2-36 52m-9-9 46-46-1 2-44 45m-9-7 41-50v2l-40 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108 431 51-42-1 2-49 41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 420 65-16-2 2-62 15m-2-14 67-4-3 1-64 4m75-7 56-3m-56 3 56-3h2v-1l-57 3h-3l2 1Zm-1-13 57-1v-2l-58 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169 404 63 5v-1l-62-4-3-1s-6 0-2 1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228 422-57-33 2 1 56 31m-8 10-51-42 2 1 50 40m-7 9-55-37 3 1 53 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206 447-46-47 2 1 45 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 454-21-61 1 2 21 59m-15 2-8-64 1 2 8 62m-12-72 1-54m-1 55 1-56v-1h-1l-1 56v2l1-1Zm-13 0 2-56h-1l-2 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174 390 9-60h-1l-9 60v2s-1 6 1 2v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197 334-38 53v-2l37-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205 342-47 46 2-2 44-45m9 7-42 50 1-2 40-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221 357-52 41 2-1 49-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227 368-64 16 2-2 62-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229 381-67 3h2l64-4m-74 7-56 3m57-4-57 4h-1v1l57-4h2l-1-1Zm1 14-57 1v2l58-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161 383-63-4v1l62 4h2s7 0 3-1h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 366 58 32h-3l-56-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108 357 51 41h-2l-49-40m6-9 55 36h-2l-53-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123 341 46 46-2-1-45-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134 333 21 62-2-2-20-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147 331 8 64-1-2-8-62m61-13-7-12-2-1h-2v-8h4l3 1v6l8 12m5 10 5-3h4s3 3 1 4l-4 4-6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 369c-14 0-25 10-25 23v2c0 13 11 23 25 23s25-10 25-23v-2c0-13-11-23-25-23Zm0 3c13 0 23 9 23 20v2c0 12-10 21-23 21-12 0-22-9-22-21v-2c0-11 10-20 22-20Zm487 18c-14 0-25 10-25 22v3c0 12 11 22 25 22s25-10 25-22v-3c0-12-11-22-25-22Zm0 3c12 0 22 9 22 20v2c0 11-10 20-22 20-13 0-22-9-22-20v-2c0-11 9-20 22-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629 394-1 7-3 9s4 3 7-1c0 0 6-10 2-12l-2-3h-3Zm1-3 2 1-1 2h-2l1-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 392s0-3 2-5c3-2 4-6 3-9h1s1 4-1 7-3 3-4 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597 437-14 23s6-21 2-33c0 0-5-29 4-42s29-36 45-39l21-3 1 5s-29 14-43 30c-13 15-13 43-16 59Zm70-102-1 6h-12l1-7 12 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 341v2l-2 1v2h9v-5h-7Zm-1-4s-6-1-7 2c0 0-2 4-1 6h1s-1-4 1-7h4m-242 85 1 4h5v-4h-6Zm27-236h1c18 0 13 9 13 26l-14 11c0 17 19 24 1 24h-1c-18 0-33-14-33-30 0-17 15-31 33-31Zm57 36h1c13 0 24 9 24 21 0 11-11 20-24 20h-1c-13 0-24-9-24-20 0-12 11-21 24-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 205v3l-2 3v3l2 10c2 1 4 2 3 3 0 0-2 3-5 4l-1 5-2 2v2l-1 1s-3 9-7 9l-14-1s-28-3-20-35c0 0 7-30 31-25 0 0 12-3 16 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 220v-2l1 1h1m-6-24 4 5c2 4 4 8 4 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 195c2 1 3 4 4 6 3 3 6 6 6 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 193c4 1 7 4 10 7l4 4c1 2 3 5 2 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 203c-3-5-9-10-15-11l-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 192c-8-6-16-4-24 1m26 2s-6-4-15-1m-40 3 6-5s5 0 3 2l-7 7s-4 0-2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417 195s2-3-9-6c-10-2-17 3-23 35s-13 35-15 39c0 0 6-3 12-15 0 0-8 17-13 21 0 0 11-5 16-16l-6 14s28-44 35-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 206-3 8-2 8-4 10-4 7-3 6-5 6-2 1m19-27-2 6-14 26m31-34v-1h1l-2 5-2 9-3 10c-2 4-8 20-13 22m22-78h-7l-6 3-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 190-4-2c-4-1-10 1-13 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 190s-15 2-24 33c0 0-8 12-16 15-4 2 14-2 21-16 0 0 6-17 18-23m12 38c1 1 4-1 2 13-2 13 1 6 0 9 0 0 17 11 23 10 0 0-4-13 1-21l-26-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 256s-18-6-27-2c-6 3-11 15-11 21-1 9-8 17-8 22l41 6 43-7s10-19 2-30c-8-12-21-8-25-8m-23-22-2 1v4m2-4v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 236c-2-1-4 3-4 4m5-2-1 2v4m-9-24-2 9-4 14-8 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 221-1 1v2l-1 8-1 8-5 15m3-27-1 5-1 2-1 7-3 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 230 1-1-2 9-6 15m9-27-8 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393 250 3-6 4-8 1-5 2-4 2-7 1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397 240 3-5 5-9 2-4 1-4 2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395 246 3-6 2-4 1-4 4-8 4-12 3-7m108 35v2l-1 2-1 3 2 7 2 2-3 3-1 3-2 1s2 1 1 2l-2 1s-2 7-5 7l-12-1s-24-2-17-26c0 0 6-21 26-18 0 0 10-2 13 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 254s10 15 5 21c0 0 17 6 22 3 0 0-2-3 1-8m-17-48c-2 0-3 2-4 3l-2 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 223c-2 0-2 2-2 3 0 2 1 4 3 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478 228 2-1 5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 230c2-1 6-3 9-2m7-4h7l8 2h4l4-2m-10 2h3l4 2h1l6-1 4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 230h-6l-11-3-1-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 229c1-2 3 0 4 1l1 1c2 1 2 3 3 5l1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 228h5s5 6 6 11l2 3m-48 18 4-5c0-2-2-3-1-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 261c2-1 2-4 2-5l-1-2m0 8 1-2 1-2 1-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 264c3-3 4-7 2-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 262v-3l1-3m-10-10 3-4 1-2m-3 9c2 0 3-4 4-5m24-21c-2-1-4 0-6 1h-5m-51-36h1c13 0 24 9 24 20v4c-3 10-12 17-24 17h-1c-13 0-24-9-24-21 0-11 11-20 24-20Zm43 87s-3-2-2 0c0 0-3-1-3 1 0 0-8-1-11 2s-3 10-3 10l24 14 25-4 9-4s4-8-3-13c-7-4-10-2-10-2s0-2-2-1h-2m110 61 2-60-70-2-3 59 71 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549 278-16-13-4 70 13 22m68-74 11-25s7-10-2-16c0 0-8-6-15 9l-17 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598 266-10-14-18 30 22 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 263v-12s-8-9-15-1l-4 52m-6-38c-5-1-9 3-10 10l-1 8c-1 7 2 13 6 15 5 1 10-3 11-10l1-8c1-7-2-13-7-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 263c-4-1-8 3-9 9l-1 7c-1 6 2 12 6 13s8-3 9-9l1-7c1-6-2-12-6-13Zm-21 6c-3-2-7 2-8 7v2c-1 5 1 10 5 12 4 1 8-3 9-8v-2c1-5-2-10-6-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 250c-3-1-6 2-7 6v4c-1 5 1 9 4 10s7-2 7-6l1-4c1-5-2-9-5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 258c-3-1-7 2-7 7l-1 6c-1 5 1 10 5 11 3 1 7-2 7-7l1-6c1-5-1-10-5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 262c-3-1-6 2-7 6l-1 7c0 4 1 8 5 9 3 1 6-2 6-6l1-7c1-4-1-8-4-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569 252-7-2c-4-1-7 2-8 8-1 5 1 10 5 11l7 2c3 1 7-2 8-7 0-6-2-10-5-12Zm27 2c-3-1-6 1-6 6l-1 2c0 5 2 9 5 10s6-2 6-6l1-3c0-4-2-8-5-9Zm-11 2c-1-1-2 0-3 2l-1 7 2 4c1 0 2-1 2-3l1-7-1-3Zm-51 26v-1m0 1h3m7-8-1-3-1 1v-1l-1 1v-2h-1l-1-1h-1v-1l-1 1v-2l-1 1v-2l-1 1v-2l-1 1-1-2v1m82 14-1-1-1 1v-1l-1 1M268 22h1c19 3 13 14 11 35l-17 11c-2 21 18 33-2 31v-1c-20-3-34-22-32-43s19-36 39-33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 48v3l-2 4-1 4c-1 6 0 10 1 12 1 3 3 3 3 5s-3 3-6 4c0 0-2 5-1 6 0 2-3 2-3 1-1 1 2 2 1 3l-3 3s-4 10-8 10l-14-4s-30-8-18-48c0 0 12-36 36-26 0 0 13-2 15 23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 35c2 1 2 4 3 6 2 5 4 11 3 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 35c2 1 3 5 4 8 2 4 5 8 4 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 31c5 2 7 7 9 11l5 6c1 2 3 6 1 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298 46c-2-7-8-13-14-16l-6-2m-1 1s3-4-10-9c-13-4-23 0-34 40-12 39-20 41-24 47 0 0 9-3 18-17 0 0-13 19-19 24 0 0 14-5 21-17l-9 17s41-51 53-79m-41 2-4 10-4 9-6 11-6 9-5 6c-2 3-4 6-7 7l-3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223 60-4 7c-4 7-15 23-21 29m56-35v-1l-3 7-4 11-4 11c-3 6-13 24-19 27m-4-66s-19 0-34 37c0 0-12 14-23 16-5 2 18 0 29-16 0 0 10-21 25-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 80c0 2 4 0 0 17s0 8-2 11c0 0 17 17 24 16 0 0-2-15 3-26l-25-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237 79-2 1-1 5m3-4-1 1-1 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 80c-1-2-4 2-4 4m6-1c-1-1-1 1-1 1l-1 5m-13-30-4 10-7 18c-3 7-8 13-12 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 67-1 2v1l-3 11-2 9-9 18m48-40s0-1 0 0l-2 6-1 2-3 9-3 9m-26-11v-1l-3 11-8 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 81c-3 9-8 17-12 26m-4-5 4-6 6-10 2-5 3-6 3-8 3-5m-26 26c0-2 2-4 4-5l7-10 3-5 2-5 4-7m-7 55 4-8 4-5 3-5 5-8 6-15 4-8m32-45c14 2 25 16 23 30l-1 5c-3 11-14 19-27 17-14-2-25-15-23-30 1-14 14-24 28-22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 56s0 3 3 4h3l-5 2m-41-34s-23 12-24 28l-13 48-5 7 17-16s9-10 12-19l8-20 5-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 57s-15 39-20 41c0 0 9-8 21-28m-1-11 1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218 60-3 3-4 5-8 5-11 6-5 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 84c3 0 6-4 9-6l10-6 5-3 1-2 4-4v-2l1-6 2-4m-37 150s3-1 10-23c8-26 5-29 13-48 7-19 9-16 28-36l21 25s5 8 3 14c-3 13-16 34-19 52-3 12 1 9-1 19-5 25-19 26-19 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 121s30 40 4 46-5-47-4-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 175s45 11 70 22c4 2 4 14 0 13l-2 2h-3c-2 3-5 1-6 1-2 2-4 0-4-2 0 0 1-6-2-7 0 0-53-6-63-10 0 0-8 4-12-17l-9-37s-4-12 2-17c6-4 12-6 18 7l11 45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 156s34 17 51 29c5 4 11 5 6 12-6 8-11 3-11 0 0 0-1-5-4-7 0 0-43-9-51-14 0 0-6 4-8-18l-6-39s-2-13 3-17c5-5 10-6 13 7l6 38 1 9Zm-23 49s-49 13-33 39c0 0 65 30 91 38l-19 26-35 56s-14 31 10 36c0 0 8 14 16 10 8-3 16-8-4-28v-22s27-27 47-54l13-17s17-20 3-32l-89-52Zm-37-19c-1 2-6 3-4 6 0 0-4 3-3 5h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 211s2-2 1 0l-1 3m34-175s5-7-13-16-32 0-48 73c-17 74-28 77-33 87 0 0 11-5 24-31 0 0-18 36-27 44 0 0 21-8 30-31 0 0 5-7-12 31 0 0 58-94 74-146m-58 4c-3 5-4 11-6 17l-5 18-8 21-9 16-7 12c-3 5-6 10-10 13l-4 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199 96-5 14c-6 12-22 43-30 54m92-146s-37-9-59 61c0 0-17 25-31 30-7 2 25-1 40-30 0 0 21-35 43-45m-32 99c-1-4-6 5-6 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199 94-6 19-9 33-17 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192 109-2 3v4l-4 20c-1 6-1 11-3 16-3 12-8 23-12 34m18-47 1-2-6 21-11 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 136c-4 17-11 31-16 47m-6-8 6-12c3-6 6-11 8-18l3-10 4-10 4-15 4-10m-36 49c1-5 3-8 5-11l11-18 4-9 3-9 5-13m-10 101 7-14 5-9 4-10 7-15c4-8 6-18 9-28l5-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 33s-32 24-34 54c0 0-10 61-18 88l-7 13 23-30s13-17 18-34l11-37 8-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193 91s-20 72-28 77c0 0 12-16 29-53m-1-20 1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 96c-2 1-3 4-5 7l-5 8c-3 4-8 7-12 10l-15 11-7 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 140c4 1 9-6 13-9l15-12 6-6 1-4 5-7 1-4 2-11 2-8m-7 114-4 4c-8 11-24 36-5 50 0 0 88 53 115 51 0 0-5 9-16 48l-14 64s-2 34 22 31c0 0 12 10 19 4 6-6 11-14-14-25l-7-21s16-36 26-68c3-7 8-22 9-29 0 0 5-16-12-21l-119-88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 237 34 69s0 5 6 1l3 7s15-1 26-8l15-10m-52-88s4 1 1 3m72-20-24 3s-4 3-1 7l24-2 6 1 3 1s1-10-2-13l-3 1-3 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 188s19 1 24 7c0 0 13 9 2 32 0 0-6 17-3 24 0 0-2 3-8 1 0 0-1-12 4-22 0 0 6-18 3-26 0 0-7-8-21-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 192s-2-5 2-6c0 0 12-2 15 7 0 0-2 4-7 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 188s0-4-4-3c0 0-3 2-2 4 0 0 2-3 6 0m10 9 11 3c-1 1-1 2-9 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 201h9l4 2c0 4-9 12-11 14-2 1-10 13-13 19-3 4-2 7-3 9l1 6h-2l-1-1s-1-9 5-17c0 0 10-16 14-19l9-9c0-1-2-5-12-3-11 2-13-3-13-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 204s12 3 10 4h-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 207h8c2 1 5 1 5 3-1 4-9 12-12 13l-8 13c-3 4-3 10-3 12v3h-2v-5l3-9s7-14 12-16c0 0 8-8 8-10 1-1-1-5-12-3-11 3-12-3-12-3m-24-6-23 5s-3 4 0 8l24-5 6 1h2s0-10-3-13l-2 1-3 3m22-1s-3-5 1-7c0 0 11-2 15 6 0 0 0 4-6 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 193s-1-3-4-2c0 0-3 2-2 4 0 0 2-3 6 0m-13 13 14-1-3-10h-14m5 58s7-8 16-4l13 37-17 7-12-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342 295 34 118 7 10 185 1s48-77 68-92l2-2 7 2s6-3 3-9c0 0-111-33-173-37-65-4-120 0-120 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222 309-1-1s12-8 17-5l21 37s7 15 25 19l56-1h23l5 17h-53s-36 4-50-5c0 0-10-4-20-21-11-17-23-40-23-40Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194 260 30 47 6-3-29-46-7 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 299s-6 0-4 4c0 0 1 2 5-1l9-6s3-3-1-2c-4 0-4 2-4 2m-29-35-6-1 1-7 10-2 3 1-2 6-6 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 257s-19 11-20-8c0 0-5-11 16-10l30-3s12 6-11 11c0 0-6 1-7 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202 254 6-7-2-1-5 6m21 57s-39 18-54 32c0 0-13 7-10 23 3 12 11 20 12 20 0 0 9-3 10-7 1-3-26-15 2-34l43-28-3-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 374h119s5-2 12 7l10 12s4 5 4 11c0 10-16 25-16 25l-6-4s14-16 13-20c-1-9-14-21-16-22l-8-1H174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168 382 26 34s6 8 14 9l77 12s12 2 21-10l-4-3s-10 6-20 5l-23-4s-21-2-34-5c-14-3-16-1-21-6-9-9-24-29-24-29l-1-4c0-2-11 1-11 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 376s-16 0-16 18c0 19 17 17 17 17s17 0 17-18c0-17-18-17-18-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170 404-1 6 105 7s12 0 13-10c2-13-10-15-15-15l-98-8 2 6 48 4 49 4s9 1 7 9c0 0 0 6-14 4l-93-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 380s-21 3-22 23c-2 19 7 23 9 24l31 4s19-12 21-24c1-11-15-24-18-26-3-3-21-1-21-1Zm28 48h78l1 11 16-4v-13l-17-2h-64s-5-1-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383 436-4 1s0 3 2 3-3 1-1 2l2 1v2h3v-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385 440 9-1v4h-10m10-5v5l191-6 1-5-192 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554 424-6 10 1 1 7-11h-2Zm4 0-7 10h2l6-10h-1Zm-11 9-1-2m0 3v-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 433v-2h-2v3l2 4v1h4v-2m-31-13 1 16h7v-16h-8Zm-120-1s18 21 71 1l-3-2s-45 18-66 0c-22-17-2 1-2 1Zm-49-83 23 75-8 6-7-5-7-1-13-51s-3-9 4-19c7-9 8-5 8-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373 417 2 3h1l-3-4v1Zm-3-16h5l2 10-2 4-2-3 3-3-2-5h-3m214 28 9-1s8 0 11-6l9-20 9-20 10-18 2 5-19 41-7 14s-3 8-12 9l-12 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619 347 30 63s3 5 5 4c0 0 1-2-1-6l-27-69-7 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653 405c5 0 10 4 10 9s-5 9-10 9-9-4-9-9 4-9 9-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654 346c-37 0-67 29-67 63v7c0 35 30 63 67 63s67-28 67-63v-7c0-34-30-63-67-63Zm-1 21c27 0 48 20 48 45v5c0 24-21 44-48 44-26 0-48-20-48-44v-5c0-25 22-45 48-45Zm-487-58c-48 0-86 35-86 79v9c0 44 38 79 86 79 47 0 86-35 86-79v-9c0-44-39-79-86-79Zm-1 26c34 0 61 25 61 56v6c0 31-27 57-61 57s-61-26-61-57v-6c0-31 27-56 61-56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 372v-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 371s-18 11-25 11c0 0 16-13 22-24 6-10 16-32 46-42a95 95 0 0 1 86 10l10 11-15 5s-24-20-51-18c-59 4-71 42-73 47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86 345 3-1-2 5 2 1-6 11-4-2 7-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648 421v40m0-41v42h1v-42h-1Zm10 0-1 41h1l1-41m-7 31v11h2v-11m-8-35-6 45h1l5-44 1-2s0-4-1-2v3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630 458 27-40v2l-26 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m624 452 33-34v1l-33 34m-6-5 30-38v2l-30 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m612 441 37-31-1 2-35 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607 433 47-12-1 1-45 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m606 423 49-2h-2l-47 3m55-5 41-3m-41 3 41-2 1-1v-1l-42 3h-1l1 1Zm-1-10 42-1v-1l-42 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m656 421 46 4 1-1-46-3-2-1s-4 0-1 1h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m700 434-42-24h2l40 24m-5 7-38-31 2 1 36 29m-5 7-40-27h2l39 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m684 453-34-35 2 1 32 33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676 458-15-45 1 1 15 44m-11 2-6-48 1 2 6 46m-9-54 1-40m-1 41 1-41v-1h-1v41l-1 1h1Zm-10 0 2-41h-1l-1 41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660 411 7-45h-1l-6 44-1 2s0 5 1 2v-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677 369-28 40 1-2 26-38m7 6-34 34 1-1 32-33m7 5-31 37 1-2 29-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m694 386-37 31 1-2 36-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699 395-47 11 1-1 46-11m1 10-49 3 2-1 47-3m-54 5-41 3m41-3-41 3h-1v1l42-3h1l-1-1Zm1 10-42 1s0 2 1 1l42-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651 406-46-3h-1l46 3h3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607 393 42 24h-2l-40-24m5-7 38 31-2-1-36-29m5-7 40 27h-2l-39-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m623 374 34 35-2-1-33-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m631 369 15 45-1-1-15-44m11-2 6 48-1-2-6-46m-475 15c7 0 12 5 12 12s-5 12-12 12-13-5-13-12 6-12 13-12Zm-8 22v54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157 403v57h2l-1-56 1-2-2 1Zm14 0-2 56s3 0 1-1l2-55m-10 42v15h3v-15m-11-47-8 60h1l8-60 1-2s0-6-1-2l-1 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133 454 37-53-1 2-36 52m-9-9 46-46-1 2-44 45m-9-7 41-50v2l-40 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108 431 51-42-1 2-49 41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 420 65-16-2 2-62 15m-2-14 67-4-3 1-64 4m75-7 56-3m-56 3 56-3h2v-1l-57 3h-3l2 1Zm-1-13 57-1v-2l-58 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169 404 63 5v-1l-62-4-3-1s-6 0-2 1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228 422-57-33 2 1 56 31m-8 10-51-42 2 1 50 40m-7 9-55-37 3 1 53 35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206 447-46-47 2 1 45 45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 454-21-61 1 2 21 59m-15 2-8-64 1 2 8 62m-12-72 1-54m-1 55 1-56v-1h-1l-1 56v2l1-1Zm-13 0 2-56h-1l-2 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174 390 9-60h-1l-9 60v2s-1 6 1 2v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197 334-38 53v-2l37-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205 342-47 46 2-2 44-45m9 7-42 50 1-2 40-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221 357-52 41 2-1 49-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227 368-64 16 2-2 62-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229 381-67 3h2l64-4m-74 7-56 3m57-4-57 4h-1v1l57-4h2l-1-1Zm1 14-57 1v2l58-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161 383-63-4v1l62 4h2s7 0 3-1h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101 366 58 32h-3l-56-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108 357 51 41h-2l-49-40m6-9 55 36h-2l-53-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123 341 46 46-2-1-45-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134 333 21 62-2-2-20-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147 331 8 64-1-2-8-62m61-13-7-12-2-1h-2v-8h4l3 1v6l8 12m5 10 5-3h4s3 3 1 4l-4 4-6-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 369c-14 0-25 10-25 23v2c0 13 11 23 25 23s25-10 25-23v-2c0-13-11-23-25-23Zm0 3c13 0 23 9 23 20v2c0 12-10 21-23 21-12 0-22-9-22-21v-2c0-11 10-20 22-20Zm487 18c-14 0-25 10-25 22v3c0 12 11 22 25 22s25-10 25-22v-3c0-12-11-22-25-22Zm0 3c12 0 22 9 22 20v2c0 11-10 20-22 20-13 0-22-9-22-20v-2c0-11 9-20 22-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m629 394-1 7-3 9s4 3 7-1c0 0 6-10 2-12l-2-3h-3Zm1-3 2 1-1 2h-2l1-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 392s0-3 2-5c3-2 4-6 3-9h1s1 4-1 7-3 3-4 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m597 437-14 23s6-21 2-33c0 0-5-29 4-42s29-36 45-39l21-3 1 5s-29 14-43 30c-13 15-13 43-16 59Zm70-102-1 6h-12l1-7 12 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 341v2l-2 1v2h9v-5h-7Zm-1-4s-6-1-7 2c0 0-2 4-1 6h1s-1-4 1-7h4m-242 85 1 4h5v-4h-6Zm27-236h1c18 0 13 9 13 26l-14 11c0 17 19 24 1 24h-1c-18 0-33-14-33-30 0-17 15-31 33-31Zm57 36h1c13 0 24 9 24 21 0 11-11 20-24 20h-1c-13 0-24-9-24-20 0-12 11-21 24-21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 205v3l-2 3v3l2 10c2 1 4 2 3 3 0 0-2 3-5 4l-1 5-2 2v2l-1 1s-3 9-7 9l-14-1s-28-3-20-35c0 0 7-30 31-25 0 0 12-3 16 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 220v-2l1 1h1m-6-24 4 5c2 4 4 8 4 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 195c2 1 3 4 4 6 3 3 6 6 6 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 193c4 1 7 4 10 7l4 4c1 2 3 5 2 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469 203c-3-5-9-10-15-11l-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 192c-8-6-16-4-24 1m26 2s-6-4-15-1m-40 3 6-5s5 0 3 2l-7 7s-4 0-2-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417 195s2-3-9-6c-10-2-17 3-23 35s-13 35-15 39c0 0 6-3 12-15 0 0-8 17-13 21 0 0 11-5 16-16l-6 14s28-44 35-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391 206-3 8-2 8-4 10-4 7-3 6-5 6-2 1m19-27-2 6-14 26m31-34v-1h1l-2 5-2 9-3 10c-2 4-8 20-13 22m22-78h-7l-6 3-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408 190-4-2c-4-1-10 1-13 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402 190s-15 2-24 33c0 0-8 12-16 15-4 2 14-2 21-16 0 0 6-17 18-23m12 38c1 1 4-1 2 13-2 13 1 6 0 9 0 0 17 11 23 10 0 0-4-13 1-21l-26-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 256s-18-6-27-2c-6 3-11 15-11 21-1 9-8 17-8 22l41 6 43-7s10-19 2-30c-8-12-21-8-25-8m-23-22-2 1v4m2-4v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 236c-2-1-4 3-4 4m5-2-1 2v4m-9-24-2 9-4 14-8 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406 221-1 1v2l-1 8-1 8-5 15m3-27-1 5-1 2-1 7-3 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 230 1-1-2 9-6 15m9-27-8 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393 250 3-6 4-8 1-5 2-4 2-7 1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397 240 3-5 5-9 2-4 1-4 2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395 246 3-6 2-4 1-4 4-8 4-12 3-7m108 35v2l-1 2-1 3 2 7 2 2-3 3-1 3-2 1s2 1 1 2l-2 1s-2 7-5 7l-12-1s-24-2-17-26c0 0 6-21 26-18 0 0 10-2 13 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 254s10 15 5 21c0 0 17 6 22 3 0 0-2-3 1-8m-17-48c-2 0-3 2-4 3l-2 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 223c-2 0-2 2-2 3 0 2 1 4 3 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478 228 2-1 5 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 230c2-1 6-3 9-2m7-4h7l8 2h4l4-2m-10 2h3l4 2h1l6-1 4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 230h-6l-11-3-1-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 229c1-2 3 0 4 1l1 1c2 1 2 3 3 5l1 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 228h5s5 6 6 11l2 3m-48 18 4-5c0-2-2-3-1-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477 261c2-1 2-4 2-5l-1-2m0 8 1-2 1-2 1-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 264c3-3 4-7 2-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 262v-3l1-3m-10-10 3-4 1-2m-3 9c2 0 3-4 4-5m24-21c-2-1-4 0-6 1h-5m-51-36h1c13 0 24 9 24 20v4c-3 10-12 17-24 17h-1c-13 0-24-9-24-21 0-11 11-20 24-20Zm43 87s-3-2-2 0c0 0-3-1-3 1 0 0-8-1-11 2s-3 10-3 10l24 14 25-4 9-4s4-8-3-13c-7-4-10-2-10-2s0-2-2-1h-2m110 61 2-60-70-2-3 59 71 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549 278-16-13-4 70 13 22m68-74 11-25s7-10-2-16c0 0-8-6-15 9l-17 37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598 266-10-14-18 30 22 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 263v-12s-8-9-15-1l-4 52m-6-38c-5-1-9 3-10 10l-1 8c-1 7 2 13 6 15 5 1 10-3 11-10l1-8c1-7-2-13-7-15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 263c-4-1-8 3-9 9l-1 7c-1 6 2 12 6 13s8-3 9-9l1-7c1-6-2-12-6-13Zm-21 6c-3-2-7 2-8 7v2c-1 5 1 10 5 12 4 1 8-3 9-8v-2c1-5-2-10-6-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554 250c-3-1-6 2-7 6v4c-1 5 1 9 4 10s7-2 7-6l1-4c1-5-2-9-5-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 258c-3-1-7 2-7 7l-1 6c-1 5 1 10 5 11 3 1 7-2 7-7l1-6c1-5-1-10-5-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550 262c-3-1-6 2-7 6l-1 7c0 4 1 8 5 9 3 1 6-2 6-6l1-7c1-4-1-8-4-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m569 252-7-2c-4-1-7 2-8 8-1 5 1 10 5 11l7 2c3 1 7-2 8-7 0-6-2-10-5-12Zm27 2c-3-1-6 1-6 6l-1 2c0 5 2 9 5 10s6-2 6-6l1-3c0-4-2-8-5-9Zm-11 2c-1-1-2 0-3 2l-1 7 2 4c1 0 2-1 2-3l1-7-1-3Zm-51 26v-1m0 1h3m7-8-1-3-1 1v-1l-1 1v-2h-1l-1-1h-1v-1l-1 1v-2l-1 1v-2l-1 1v-2l-1 1-1-2v1m82 14-1-1-1 1v-1l-1 1m-206-56s2 9 7 14c0 0 3 1 3 3l-1 14s-15-3-19 1l-2 17 29 6 8-14 3-6 5-21-1-18-19-16-3-10-10-4s-5-3-15 2h8s-5-1-9 4l6-2-3 3s-8 7-11 16c0 0-4 12-7 15 0 0-8 9-14 11 0 0 11-2 17-8l5-8-15 30s8-5 16-22 0 1 0 1l-1 2-12 24 13-21s-9 22-14 27c0 0 8-6 11-11 0 0-10 16-12 17 0 0 11-6 16-16l-6 15s15-23 15-25l-11 25s11-10 14-27l5-9 4-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404 227-6 27s7-19 8-32m-4 9-8 25 7-16 3-13-2 4Zm11 5-2 4 2-2v3l1-3 1 4v-3h1l-1 4 1-2v2l1-2v-4l-4-1ZM258 75l-14 27 10 21 2-7s0-10 4-16l9 2 5-7m-67-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 58s-11 6-19 29c0 0-13 14-25 17 0 0 18-4 22-8 0 0-13 13-20 13 0 0 12 0 16-4 0 0-2 7-14 16l-17 16 19-14s-10 15-13 17c0 0 13-8 21-17 0 0-8 21-14 30 0 0 10-8 20-24l-18 35 13-22-7 19 5-9-4 11 13-28-16 45 10-21-6 23 6-16-1 10-4 15 6-15c0-2 9-10 9-10l5-10 4-6s-7 22-15 29l-5 6 14-11 11-16s-19 34-24 38c0 0 16-13 17-12l-1 5s-3 0-2 4c0 0 6 11 8 10 3-1 25 27 26 29 1 1 21-16 21-16l-4-5-5-2h3s4-8 1-13c-3-4-3-13-2-15l17-38s8-17-5-26 5-17 5-17l11-70-12-11s-16-1-28 11c-11 11-22 28-22 28Zm230 201 1-1s-2-2 1-9l7 1 8-15-13-12-13 10-2 23 10 4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargo);
export default __webpack_public_path__ + "static/media/cargo.d340060a1a1485e29921bad1597785e6.svg";
export { ForwardRef as ReactComponent };